import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const getMachineMeta = prop('machineMeta');

export const getSpinnerDeactivated = createSelector(getMachineMeta, prop('spinnerDeactivated'));

export const getStepper = createSelector(getMachineMeta, prop('stepper'));

export const getStepperMax = createSelector(getStepper, prop('max'));

export const getStepperValue = createSelector(getStepper, prop('value'));
